import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject } from "aurelia-framework";
import {
    DeleteDepartmentRequest, DeleteDepartmentResponse, PersistDepartmentResponse, PersistDepartmentRequest, CloneDepartmentRequest,
    CloneDepartmentResponse,
    GetDepartmentRequest,
    GetDepartmentResponse
} from "../../models/manage/departments.models";
import { DepartmentRoutes } from "../../constants/departments/departments.constants";
import { ChangeActivationStateRequest, ChangeActivationStateResponse } from "../../models/manage/branches.models";

@autoinject()
export class ManageDepartmentsClientService {

    constructor(private requestClient: RequestClientService) {
    }

    getDepartment(request: GetDepartmentRequest): Promise<GetDepartmentResponse> {
        return this.requestClient.get<GetDepartmentResponse>(DepartmentRoutes.GetDepartment, request);
    }

    deleteDepartment(request: DeleteDepartmentRequest): Promise<DeleteDepartmentResponse> {
        return this.requestClient.post<DeleteDepartmentResponse>(DepartmentRoutes.DeleteDepartment, {}, request);
    }

    saveDepartment(request: PersistDepartmentRequest): Promise<PersistDepartmentResponse> {
        return this.requestClient.post<PersistDepartmentResponse>(DepartmentRoutes.SaveDepartment, {}, request);
    }

    cloneDepartment(request: CloneDepartmentRequest): Promise<CloneDepartmentResponse> {
        return this.requestClient.post<CloneDepartmentResponse>(DepartmentRoutes.CloneDepartment, {}, request);
    }

    changeDepartmentActivationState(request: ChangeActivationStateRequest): Promise<ChangeActivationStateResponse> {
        return this.requestClient.post<ChangeActivationStateResponse>(DepartmentRoutes.ChangeActivationState, {}, request);
    }
}